import React, { Component } from 'react';

import apiServer from '../../utils/backend'

import AuxWrapper from '../AuxWrapper/AuxWrapper'

import { Snackbar } from '@material-ui/core';

const withErrorHandler = (WrappedComponent) => {
    return class extends Component {

        // Enable management of the Snackbar
        state = {
            message: '',
            isError: false,
            showSnack: false
        }

        /* We rather use component*WILL*Mount:
            -> the below calls have no side effect (we just register)
            -> the error interceptor is registered even if the very first rendering fails,
                e.g. that will means that the componentDidMount method of this level is never called
        */
        componentWillMount() {
            // this.reqInterceptor = ... : This syntax enables addition of a global variable lazily.
            this.reqInterceptor = apiServer.interceptors.request.use(
                requestConfig => {
                    // this.setState({ error: null });
                    return requestConfig;
                }, error => {
                    console.log("could not register request interceptor:", error)
                    return Promise.reject(error);
                }
            );

            this.resInterceptor = apiServer.interceptors.response.use(
                response => {
                    // We don't display an OK message on GET requests.
                    if (response.config.method !== 'get') {
                        this.setState({
                            message: 'OK',
                            isError: false,
                            showSnack: true,
                        });
                    }
                    return response;
                }, error => {
                    console.log("request failed with error: ", error)
                    this.setState({
                        message: '' + error,
                        isError: true,
                        showSnack: true,
                    });
                    return Promise.reject(error);
                }
            );
        }

        // Don't forget to dispose (eject) the interceptors to avoid memory leaks
        componentWillUnmount() {
            apiServer.interceptors.request.eject(this.reqInterceptor);
            apiServer.interceptors.response.eject(this.resInterceptor);
        }

        disposeModal = () => {
            // this.setState({ error: null });
        }

        handleRequestClose = () => {
            this.setState({
                message: '',
                isError: false,
                showSnack: false,
            });
        };

        render() {
            return (
                <AuxWrapper>
                    {/* <Modal
                        show={this.state.error}
                        modalClosed={this.disposeModal}>
                        {this.state.error ? this.state.error.message : null}
                    </Modal> */}
                    <WrappedComponent {...this.props} />
                    <Snackbar
                        open={this.state.showSnack}
                        message={this.state.message}
                        autoHideDuration={3000}
                        onClose={this.handleRequestClose}
                    />
                </AuxWrapper>
            );
        }
    }
}

export default withErrorHandler;
